module.exports = __webpack_public_path__ + "img/bread_outside.88c5ba84.jpeg";